import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Discover from '../Discover/Discover';
import Home from '../Home/Home';
// import Home2 from '../Home/Home2';
import Projects from '../Projects/Projects';
import classes from './App.module.scss';

import { animateScroll as scroll } from 'react-scroll';
import Fanolly from '../Fanolly/Fanolly';
import Contacts from '../Contacts/Contacts';
import loader from '../../assets/images/loader.gif';

// const elemNames = ['home', 'discover', 'projects', 'fanolly', 'contacts', 'footer'];
// let active = Number.parseInt(window.pageYOffset / window.innerHeight);
// let scrolled = false, scrollingUp = false, scrollingDown = false, pageLoaded = false;

const elemNames = ['home', 'discover', 'projects', 'fanolly', 'contacts', 'footer'];
// let active = Number.parseInt(window.pageYOffset / window.innerHeight);
let active = 0;
const scrollEvent = (remove) => {
  if (!remove) active = 0;
  let scrolled = false, scrollingUp = false, scrollingDown = false, pageLoaded = false;

  var self = this || {};
  self._lastScroll = self._thisScroll = new Date().getTime();
  
  function wheelScrollHandler(e) {
    var ev = e || window.event;
    self._thisScroll = new Date().getTime();

    var duration = 700;
    var durOffset = self._thisScroll - self._lastScroll;
    durOffset = durOffset < duration ? durOffset : 0;
    scrolled = self._thisScroll - self._lastScroll > (active < elemNames.length-1 ? duration - 10 : 100);

    if (!e.target.classList.contains('scrollable') && !e.target.closest('.scrollable')) {
      e.preventDefault();
      e.stopPropagation();
      // console.log('OOOOOOOO', e);
      console.log('scrolled', scrolled, e);
      if (true) {
        
        // scrolled = true;
        // setTimeout(()=> { scrolled = false }, 200);
        // self._lastScroll = self._thisScroll;

        var delta = ev.detail ? ev.detail * (-120) : (
            ev.wheelDelta ? ev.wheelDelta : (
            ev.deltaY ? (ev.deltaY * 1) * (-120) : 0));

            console.log('delta :>> ', delta);
    
        if (e.deltaY < 0 || delta > 0) {
          if (active > 0 && !scrollingUp) {
            self._lastScroll = self._thisScroll;
            // console.log('TO TOP');
            if (scrolled)
              active--;
            // scrollingUp = true;
            // setTimeout(()=> scrollingUp = false, 500);
          } 
          scroll.scrollTo(active * window.innerHeight, {
            duration: duration - durOffset
          });
          // Events.scrollEvent.register('end', ()=> { movingUp = false; })
        }
        else if (e.deltaY > 0 || delta < 0) {
          if (active < elemNames.length - 1 && !scrollingDown) {
            self._lastScroll = self._thisScroll;
            // console.log('TO BOTTOM');
            if (scrolled)
              active++;
            // scrollingDown = true;
            // setTimeout(()=> scrollingDown = false, 500);
          } 
          scroll.scrollTo(active * window.innerHeight, {
            duration: duration - durOffset
          });
          // Events.scrollEvent.register('end', ()=> { movingDown = false; })
        }
      }
    }
  }

  // modern Chrome requires { passive: false } when adding event
  var supportsPassive = false;
  try {
    window.addEventListener("test", null, Object.defineProperty({}, 'passive', {
      get: function () {
        supportsPassive = true;
        return supportsPassive;
      }
    }));
  } catch (e) {}

  var wheelOpt = supportsPassive ? {
    passive: false
  } : false;
  var wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';
  
  // call this to Disable
  function disableScroll() {
    window.addEventListener('DOMMouseScroll', wheelScrollHandler, false); // older FF
    window.addEventListener(wheelEvent, wheelScrollHandler, wheelOpt); // modern desktop
    // window.addEventListener('touchmove', wheelScrollHandler, wheelOpt); // mobile
  }
  function enableScroll() {
    window.removeEventListener('DOMMouseScroll', wheelScrollHandler, false); // older FF
    window.removeEventListener(wheelEvent, wheelScrollHandler, wheelOpt); // modern desktop
    // window.addEventListener('touchmove', wheelScrollHandler, wheelOpt); // mobile
  }

  // if (!remove) disableScroll();
  // if (remove) enableScroll();

  enableScroll();
  disableScroll();
}


function checkMobile() {
  let isMobile = false;
  if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
    isMobile = true;
  }
  if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) 
      || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) { 
      isMobile = true;
      console.log('object mobile');
  }
  isMobile = window.matchMedia("only screen and (max-width: 775px)").matches;
  return isMobile;
}
checkMobile();

// scrollEvent();

const size = 15; // just change this value;
const maskSizeRatio = size / 10;

function App() {
  const maskMinSize = Math.max(window.innerWidth * 0.06 * maskSizeRatio, 80 * maskSizeRatio);
  const [isMobile, setIsMobile] = useState(checkMobile());
  const [maskSize, setMaskSize] = useState(maskMinSize);
  const [loaded, setLoaded] = useState(false);
  const [videoEnded, setVideoEnded] = useState(false);
  console.log('MOBILE', isMobile);

  useEffect(()=> {
    const resizeHandler = ()=> {
      if (window.innerWidth <= 775 && !isMobile) {
        setIsMobile(true);
      }
      else if (window.innerWidth > 775 && isMobile) {
        setIsMobile(false);
      }
      // scrollEvent(true);
    }
    window.addEventListener('resize', resizeHandler);
    window.addEventListener('load', ()=> {
      setLoaded(true);
    });

    return ()=> window.removeEventListener('resize', resizeHandler);
  }, [isMobile]);

  useEffect(()=> {
    if (loaded && !videoEnded) {
      setTimeout(()=> setVideoEnded(true), 100);
    }

    if (!loaded && !videoEnded)
      document.body.style = 'overflow: hidden';
    else if (loaded && videoEnded) {
      window.scrollTo(0, 0);
      scrollEvent();
      document.body.style = 'overflow: auto';
    }
  }, [loaded, videoEnded]);

  const backToTop = ()=> {
    scroll.scrollToTop({ duration: 1000 });
    active = 0;
  }

  return (
    <div className={classes.App}>
      <Home maskSize={maskSize} setMaskSize={setMaskSize} isMobile={isMobile} ratio={maskSizeRatio} />
      <Discover maskSize={maskSize} setMaskSize={setMaskSize} isMobile={isMobile} ratio={maskSizeRatio} />
      <Projects maskSize={maskSize} setMaskSize={setMaskSize} isMobile={isMobile} />
      <Fanolly maskSize={maskSize} setMaskSize={setMaskSize} isMobile={isMobile} />
      <Contacts maskSize={maskSize} setMaskSize={setMaskSize} isMobile={isMobile} toTop={backToTop} />

      <AnimatePresence>

        { (!loaded || !videoEnded) && 
          <motion.div className={classes.Loader}
            initial={{opacity: 1}}
            exit={{ opacity: 0 }}
          >
            {/* <video className={classes.Video} autoPlay muted onEnded={()=> setVideoEnded(true)}>
                <source src="https://fiverr-media-res.cloudinary.com/video/upload/t_fiverr_hd/v1/video-secured-attachments/message/attachments/7d9550977ca333a914bdfb97314b0b46-1603338908832/Siggy%20display?__cld_token__=exp=1603363854~hmac=72082e7f6572ddabf34bc5914ca8d32fcbdbf29cb46019ef77ae05c165ea4c9c" type='video/mp4' />
            </video> */}
            <img src={loader} alt="L" className={classes.Img} />
            {/* <p>Loading 
              <span style={{ animationDelay: 200 * 0 + 'ms' }}> .</span>
              <span style={{ animationDelay: 200 * 1 + 'ms' }}> .</span>
              <span style={{ animationDelay: 200 * 2 + 'ms' }}> .</span>
            </p> */}
          </motion.div>
        }
      </AnimatePresence>
    </div>
  );
}

// ">0.05%",
//       "not dead",
//       "not op_mini all",
//       "iOS >= 8",
//       "Safari >= 8"

export default App;
